import apiNetwork from '@/api/vo/network';

const defaultState = () => ({
	listGenealogy: [],
	listMembership: [],
	membershipPagination: '',
	listProspek: [],
	prospekPagination: '',
	listSponsorisasi: [],
	sponsorisasiPagination: '',
	dataSponsorisasi: {},
	listDownline: [],
	downlinePagination: '',
	listNetGrowth: [],
	netGrowthToday: {},
	netGrowthPagination: '',
	responSukses: {},
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {};

const mutations = {
	setGenealogy(state, data) {
		state.listGenealogy = data.data;
	},
	setGenealogyMobile(state, data) {
		state.listGenealogy = data.data;
	},
	setMembership(state, data) {
		state.listMembership = data.data;
		state.membershipPagination = data.pagination;
	},
	setProspek(state, data) {
		state.listProspek = data.data;
		state.prospekPagination = data.pagination;
	},
	setSponsorisasi(state, data) {
		state.listSponsorisasi = data.data;
		state.sponsorisasiPagination = data.pagination;
		state.dataSponsorisasi = data;
	},
	setDownline(state, data) {
		state.listDownline = data.data;
		state.downlinePagination = data.pagination;
	},
	setNetGrowth(state, data) {
		state.listNetGrowth = data.data;
		state.netGrowthPagination = data.pagination;
	},
	setNetGrowthToday(state, data) {
		state.netGrowthToday = data.data;
	},
	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
};

const actions = {
	getGenealogy({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getGenealogy(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setGenealogy', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setGenealogy', []);
				reject()
			});
		});
	},

	getGenealogyMobile({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getGenealogyMobile(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setGenealogyMobile', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setGenealogyMobile', []);
				reject()
			});
		});
	},

	getMembership({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getMembership(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMembership', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMembership', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getProspekList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getProspekList(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setProspek', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setProspek', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getSponsorisasi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getSponsorisasi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSponsorisasi', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSponsorisasi', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getDownline({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getDownline(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDownline', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDownline', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getNetGrowth({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getNetGrowth(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setNetGrowth', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setNetGrowth', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getNetGrowthToday({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiNetwork.getNetGrowthToday(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setNetGrowthToday', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setNetGrowthToday', {});
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};